import React, { useState } from 'react'
import DashboardLayout from '../../../../layouts/Dashboard'
import { Col, Row, Form, Container, Button, Spinner } from 'react-bootstrap'
import api from '../../../../services/api'
import { toast } from 'react-toastify'
import { errorApi } from '../../../../utils/errorApi'
import { useNavigate } from 'react-router-dom'
import { IMaskInput } from 'react-imask'

import styles from './styles.module.css'
import { useLoading } from '../../../../hooks/LoadingContext'
import LoadingSpinner from '../../../../components/LoadingSpinner/LoadingSpinner'

const VeiculosNovo: React.FC = () => {
  const [board, setBoard] = useState<string>('')
  const [model, setModel] = useState<string>('')
  const [color, setColor] = useState<string>('')
  const [capacity, setCapacity] = useState<number>()
  const [start_at, setStart_at] = useState<string>('')
  useState<string>('')
  const { isLoading, setIsLoading } = useLoading()
  const navigate = useNavigate()

  const handleSubmit = async (event: any) => {
    event.preventDefault()

    setIsLoading(true)

    if (!board || !model || !color || !capacity) {
      toast.error('Você precisa preencher todos os campos obrigatórios!')
      setIsLoading(false)
      return
    }
    try {
      await api.post('/company/vehicles', {
        board: board,
        model: model,
        color: color,
        capacity: capacity,
        start_at: start_at ? new Date(start_at).toISOString() : null,
      })

      setIsLoading(false)
      toast.info('Veículo cadastrado com sucesso!', { autoClose: 3000 })
      navigate('/empresa/veiculos')
    } catch (err) {
      toast.error(errorApi(err, 'Falha ao cadastrar o motorista! Verifique os dados.'))
      setIsLoading(false)
    }
  }

  const isValidModel = () => {
    return board && model && color && capacity;
  };

  return (
    <DashboardLayout backgroundColor="#F8F8F8" pageName="Cadastrar veículo">
      <LoadingSpinner text="Salvando informações. Aguarde..." />
      <Container>
        <h2 style={{ textAlign: 'center' }}>Novo Veículo</h2>
        <Col className={styles.form_container}>
          <Row style={{ marginTop: 15, textAlign: 'left' }}>
            <Col md={6}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Placa*
              </Form.Label>
              <Form.Control
                className={styles.input}
                as={IMaskInput}
                mask="*******"
                placeholder="Digite aqui a placa"
                value={board}
                onChange={(event) => setBoard(event.target.value.toUpperCase())}
              />
            </Col>
            <Col md={6}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Modelo*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui o modelo do veículo"
                value={model}
                onChange={(event) => setModel(event.target.value)}
              />
            </Col>
          </Row>

          <Row style={{ marginTop: 15, textAlign: 'left' }}>
            <Col md={6}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Cor*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui a cor do veículo"
                value={color}
                onChange={(event) => setColor(event.target.value)}
              />
            </Col>
            <Col md={6}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Capacidade de carga (Kg)*
              </Form.Label>
              <Form.Control
                className={styles.input}
                placeholder="Digite aqui a capacidade do veículo em quilos"
                value={capacity}
                onChange={(event) => setCapacity(Number(event.target.value) || 0)}
              />
            </Col>
          </Row>

          <Row style={{ marginTop: 15, textAlign: 'left' }}>
            <Col md={6}>
              <Form.Label style={{ fontWeight: '500', fontSize: 14, color: '#667080' }}>
                Adquirido na data
              </Form.Label>
              <Form.Control
                className={styles.input}
                type="date"
                value={start_at}
                onChange={(event) => setStart_at(event.target.value)}
              />
            </Col>
          </Row>

          <Col style={{ textAlign: 'right' }}>
            <Button
              className={styles.submit_button}
              disabled={isLoading || !isValidModel()}
              onClick={handleSubmit}
            >
              {isLoading ? (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{
                    color: '#fff',
                    marginRight: 10,
                  }}
                />
              ) : (
                'Cadastrar veículo'
              )}
            </Button>
          </Col>
        </Col>
      </Container>
    </DashboardLayout>
  )
}

export default VeiculosNovo
